import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CreateParkComponent } from "./create-park/create-park.component";
import { Park } from "../../../models/park";
import { ParkType } from "../../../models/parkType";
import { ParksHandlerService } from "../../../api-handlers/parks-handler.service";
import { Router } from "@angular/router";
import { UsersAdministrateParksHandlerService } from "../../../api-handlers/users-administrate-parks-handler.service";
import { AuthService } from "../../../auth-n-routing/auth-service.service";
import * as _ from "lodash";

@Component({
  selector: "app-superadmin-tools",
  templateUrl: "./superadmin-tools.component.html",
  styleUrls: ["./superadmin-tools.component.css"],
})
export class SuperadminToolsComponent implements OnInit {
  @ViewChild(CreateParkComponent, { static: true })
  createPark: CreateParkComponent;

  @Output() statusChanged = new EventEmitter();
  parks: Park[];
  parkTypes: ParkType[];
  visibleParks: Park[];
  selectedPark: Park;
  parkId = "";
  parkName = "";

  constructor(
    public authService: AuthService,
    private changeDetector: ChangeDetectorRef,
    private parkService: ParksHandlerService,
    private userAdministrateParkService: UsersAdministrateParksHandlerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.reload();
    this.userAdministrateParkService.newParkCreated$.subscribe((park) => {
      this.reload();
    });
  }

  reload() {
    this.reloadParks();
    this.reloadParkTypes();
  }

  reloadParks() {
    this.parkService.getAllParks().then((data: Park[]) => {
      this.parks = data;
      this.parks = _.sortBy(this.parks, ["name"]);
	  this.changeDetector.detectChanges();
    });
  }

  reloadParkTypes() {
    this.parkService.getParkTypes().then((parkTypes: ParkType[]) => {
      this.parkTypes = parkTypes;
	  this.changeDetector.detectChanges();
    });
  }

  parkCreated() {
    this.reloadParks();
    this.statusChanged.next(undefined);
  }

  vehicleCreated() {
    this.statusChanged.next(undefined);
  }

  parkTypeChanged(parkType: ParkType) {
    this.visibleParks = this.parks.filter((park) => {
      return "" + park.type_id === "" + parkType.id;
    });
    this.selectedPark = undefined;
    this.router.navigate(['/dashboard/super-admin/createpark']);
  }

  selectParkChange(event) {
    this.parkId = this.selectedPark.id;
    this.parkName = encodeURI(this.selectedPark.name);
    this.router.navigate(['/dashboard/super-admin/createpark']);
  }
}
